import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useChat } from '../context/ChatContext';
import { ChatSystem } from '../components/chat';

/**
 * Messages Page - Full-page chat interface
 *
 * Route: /messages or /messages/:chatId
 */

export default function Messages() {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const { selectChat } = useChat();

  // Handle initial chat selection from URL
  useEffect(() => {
    if (chatId) {
      selectChat(chatId);
    }
  }, [chatId, selectChat]);

  const handleClose = () => {
    navigate('/dashboard');
  };

  return (
    <ChatSystem
      isOpen={true}
      onClose={handleClose}
      initialChatId={chatId}
    />
  );
}
